import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../store/language-context';
import SpeakerCard from './SpeakerCard';


const SpeakersCarousel = ({ speakers }) => {
    const { t } = useTranslation();
    const { language } = useLanguage();
    const [currentSlide, setCurrentSlide] = useState(0);
    const slidesPerView = 4; // Number of cards visible at once
    
    const totalSlides = Math.ceil(speakers.length / slidesPerView);
    
    const nextSlide = () => {
        setCurrentSlide((prev) => (prev + 1) % totalSlides);
    };
    
    const prevSlide = () => {
        setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    };
    
    return (
        <div className="bg-[#6A2F38] mt-4 p-4">
            <div className="container mx-auto px-4">
                {/* Section Title */}
                <h2 className={`text-3xl font-bold text-white  text-center mb-16 ${language === 'ar' ? 'font-arabic' : ''}`}>
                    {t('events.speakers.title')}
                </h2>
                
                {/* Carousel Container */}
                <div className="relative">
                    {/* Navigation Buttons */}
                    <button 
                        onClick={prevSlide}
                        className="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white/10 hover:bg-white/20 rounded-full p-2"
                        aria-label="Previous slide"
                    >
                        <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                    
                    <button 
                        onClick={nextSlide}
                        className="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white/10 hover:bg-white/20 rounded-full p-2"
                        aria-label="Next slide"
                    >
                        <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                    
                    {/* Speakers Grid */}
                    <div className="">
                        <div 
                            className="flex transition-transform duration-300 ease-in-out"
                            style={{
                                transform: `translateX(${currentSlide * -100}%)`,
                            }}
                        >
                            {speakers.map((speaker, index) => (
                                <div 
                                    key={index}
                                    className="w-full md:w-1/2 lg:w-1/4 flex-shrink-0"
                                >
                                    <SpeakerCard {...speaker} />
                                </div>
                            ))}
                        </div>
                    </div>
                    
                    {/* Pagination Dots */}
                    <div className="flex justify-center mt-8 gap-2">
                        {Array.from({ length: totalSlides }).map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentSlide(index)}
                                className={`w-2 h-2 rounded-full transition-all ${
                                    currentSlide === index 
                                        ? 'bg-white w-4' 
                                        : 'bg-white/50'
                                }`}
                                aria-label={`Go to slide ${index + 1}`}
                            />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SpeakersCarousel;
